import baseTheme from '../baseTheme';
var MuiDialogTitle = {
    root: {
        fontSize: baseTheme.typography.h2.fontSize,
        fontWeight: baseTheme.typography.h2.fontWeight,
    },
};
export default MuiDialogTitle;
//# sourceMappingURL=MuiDialogTitle.js.map